import { invokeApi } from "../invokeApi";

export const _Add_Ad_Account = async (data) => {
  const requestObj = {
    path: `/api/ad_account/add_ad_account`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _Update_Ad_Account = async (data, id) => {
  const requestObj = {
    path: `/api/ad_account/update_ad_account_by_id/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const _Delete_Ad_Account = async (id) => {
  const requestObj = {
    path: `/api/ad_account/delete_ad_account_by_id/${id}`,
    method: "DELETE",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _Find_Ad_Account_By_Id = async (id) => {
  const requestObj = {
    path: `/api/ad_account/find_ad_account_by_id/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const _List_Ad_Account_For_Admin = async (data, page, limit) => {
  const requestObj = {
    path: `/api/ad_account/list_ad_account_for_admin?page=${page}&limit=${limit}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const Scree_Base_List = async (data) => {
  const requestObj = {
    path: `/api/app_api/get_listing_with_search`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const _Update_Ad_Account_status = async (data, id) => {
  const requestObj = {
    path: `/api/ad_account/update_status_ad_account/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const List_Sub_Req_Admin = async (data, page, limit) => {
  const requestObj = {
    path: `/api/products/list_cancel_subscription_request_for_admin?page=${page}&limit=${limit}`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const change_Status_OF_Sub = async (data) => {
  const requestObj = {
    path: `/api/products/cancel_product_subscription`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};

export const Get_Account_Details = async (id) => {
  const requestObj = {
    path: `/api/ad_account/withdraw_fund_detail_by_id/${id}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const Update_Account_Info = async (id, data) => {
  const requestObj = {
    path: `/api/ad_account/update_ad_account_by_id_admin/${id}`,
    method: "PUT",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data || {},
  };
  return invokeApi(requestObj);
};
